import { useIntl } from 'react-intl';

import EmptyDashboardIcon from '@/assets/icons/empty-dashboard.svg';
import { EmptyState } from '@/components/ui/empty-state';
import { useTableContext } from '@/contexts/table-context';

interface NoOpeningsProps {
  hasActiveFilters: boolean;
  onCleared?: () => void;
}

export function NoOpenings({ hasActiveFilters, onCleared }: NoOpeningsProps) {
  const intl = useIntl();
  const { filters, resetQueryState } = useTableContext();

  if (hasActiveFilters) {
    return (
      <EmptyState
        header={intl.formatMessage({
          defaultMessage: 'No openings match',
          description:
            'Select-openings table: search or filters returned no rows',
        })}
        description={intl.formatMessage({
          defaultMessage: 'Try a different opening name or clear the filters.',
          description:
            'Select-openings table: what to do when the filtered list is empty',
        })}
        buttonTitle={intl.formatMessage({
          defaultMessage: 'Clear filters',
          description:
            'Select-openings table: reset search and Brand, Position, and Location filters',
        })}
        onClick={() => {
          resetQueryState({
            filters: {
              ...filters,
              locationIds: [],
              positionIds: [],
              brandIds: [],
            },
            searchQuery: undefined,
            sorting: [],
          });
          onCleared?.();
        }}
      />
    );
  }

  return (
    <EmptyState
      icon={EmptyDashboardIcon}
      header={intl.formatMessage({
        defaultMessage: 'No openings available',
        description:
          'Select-openings table: account has no active sourcing-enabled openings',
      })}
      description={intl.formatMessage({
        defaultMessage: 'There are no active openings with sourcing enabled.',
        description: 'Select-openings table: why the unfiltered list is empty',
      })}
    />
  );
}
